<template>
  <div>
    <div class="modal-overlay modal-cover-overlay z-index-styling">
      <div class="modal-cover modal-sm-md rounded-5" :class="modal_style">
        <div class="modal-cover-body">
          <!-- CLOSE DIALOG -->
          <div class="dialogDismiss closeAvatarBtn" v-if="show_close">
            <button
              type="button"
              class="close_dialog white"
              @click="$emit('closeModal')"
            ></button>
          </div>

          <!-- MODAL COVER BODY -->
          <slot name="modal-cover-body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalCover",

  props: {
    modal_style: String,
    show_close: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.z-index-styling {
  z-index: 10000;
}
</style>
